export default function() {
  return (input = '', max) => {
    return input.length <= max ? input : input.slice(0, max) + '...'
  }
}
